// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dwY5","newExpiryDate":"styles_newExpiryDate__19HHI","footer":"styles_footer__2aJYp"};